module.exports = __webpack_public_path__ + "img/product_pressalit_bathe04.416cc5aa.jpg";